var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-auth-panel",attrs:{"fluid":""}},[_c('v-toolbar',{attrs:{"dark":"","color":"indigo","flat":""}},[_c('v-toolbar-title',[_vm._v("幹部列表")])],1),_c('v-container',[_c('v-layout',[_c('auth-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }